import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <div className="login-content-wrapper">
          <div className="login-header">
            <h2>Sign In to QED System Design</h2>
            <p>Access exclusive content and save your progress.</p>
          </div>
          
          <Authenticator>
            {({ signOut, user }) => {
                if (user) {
                    setTimeout(() => navigate('/'), 1000);
                    return (
                        <div className="logged-in-message">
                            <h3>Welcome, {user.username}!</h3>
                            <p>Redirecting you to home...</p>
                            <button onClick={signOut}>Sign out</button>
                        </div>
                    );
                }
                return <></>;
            }}
          </Authenticator>
      </div>
    </div>
  );
};

export default Login;
